// First: catch errors of everything below
import './bugsnag'
import { t } from './i18n'

// Global for legacy code and console
window.t = t;

// Mobile navigation toggle
window.toggleMobileNav = function() {
    const nav = document.getElementById('mobile-nav');
    const burger = document.getElementById('burger');
    nav.classList.toggle('open');
    burger.classList.toggle('open');
    lockScroll(nav.classList.contains('open'));
};

// Styles
import '../sass/app.scss'

import ClipboardJS from 'clipboard'
import {lockScroll} from './utils/scroll-lock';
import {request} from './utils/http';
import {on} from './utils/events';

import './prefix-dispatcher';
import './home';
import './champions';
import './faq';


import InfiniteAjaxScroll from '@webcreate/infinite-ajax-scroll';

// Scripts
import './filter'
import './modules/entity-form'
import { trackInteraction, initSocialTracking } from './modules/interaction-tracker'
import { initDashboardSettings } from './modules/dashboard-settings'
import { initTeamSlots } from './modules/dashboard-team-slots'
import { initListPage, trackCreateCta } from './modules/list-page'
import { initPageFab } from './modules/page-fab'
import { initClashBanner } from './modules/clash-banner'
import { initModals, openModal } from './modules/modal'
import { initTooltips } from './modules/tooltip'
import { initSkinsSliders } from './modules/skins-slider'

// Toast notification function
const toastIcons = {
    success: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="icon icon--14"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"/></svg>',
    error: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="icon icon--14"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd"/></svg>',
    info: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="icon icon--14"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd"/></svg>',
    warning: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="icon icon--14"><path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/></svg>',
};

window.showToast = function(text, type = 'success', duration = 5000) {
    const toast = document.createElement('div');
    toast.className = `pf-toast pf-toast--${type}`;
    toast.innerHTML = `
        <div class="pf-toast__icon">${toastIcons[type] || toastIcons.success}</div>
        <span class="pf-toast__text">${text}</span>
        <button type="button" class="pf-toast__close">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="icon icon--12"><path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/></svg>
        </button>
    `;

    // A popover goes to the top layer, so the toast shows above an open modal dialog and outlives it;
    // without popover support (iOS < 17) it's a plain fixed element
    toast.popover = 'manual';
    document.body.appendChild(toast);
    toast.showPopover?.();

    const closeBtn = toast.querySelector('.pf-toast__close');
    const hide = () => {
        toast.classList.add('hiding');
        setTimeout(() => toast.remove(), 300);
    };

    closeBtn.addEventListener('click', hide);
    setTimeout(hide, duration);
};

// Party card stats (premium cards on load and after infinite scroll, the others on first expand). The server
// renders them into the container's .stats-content, .stats-skeleton shows until then or says it failed
async function loadStats(container, url) {
    if (!url || container.dataset.loaded) return;
    container.dataset.loaded = '1';

    const skeleton = container.querySelector('.stats-skeleton');
    const content = container.querySelector('.stats-content');
    try {
        content.innerHTML = await (await request(url, {method: 'POST'})).text();
        skeleton.classList.add('hidden');
        content.classList.remove('hidden');
    } catch (e) {
        delete container.dataset.loaded;
        skeleton.innerHTML = '<span class="text-muted">' + t('Не удалось загрузить статистику') + '</span>';
    }
}

function loadPremiumStats(root) {
    root.querySelectorAll('.premium-stats-container').forEach((container) => loadStats(container, container.dataset.statsUrl));
}

document.addEventListener('DOMContentLoaded', function () {
    initModals();
    initTooltips();

    // Initialize interaction tracking for social links
    initSocialTracking();

    // Initialize dashboard settings if on settings page
    initDashboardSettings();
    initTeamSlots();
    initListPage();
    initPageFab();
    initClashBanner();

    // Autoload stats for premium cards on page load
    loadPremiumStats(document);

    initSkinsSliders();

    const partiesList = document.querySelector('.parties-list');
    const hasPartyCards = partiesList?.querySelector('.party-card') !== null;
    const hasTeamCards = partiesList?.querySelector('.team-card') !== null;

    // Only the paginated lists include the spinner (base.partials.spinner); the player profile reuses
    // .parties-list for its cards, and without the spinner InfiniteAjaxScroll throws and stops this handler
    if (partiesList !== null && (hasPartyCards || hasTeamCards) && document.querySelector('.ias-spinner') !== null) {
        // .list-cta (fresh/stale divider) can land on any page, so it's loaded along with the cards
        const itemSelector = hasTeamCards ? '.team-card' : '.party-card, .list-cta';
        let ias = new InfiniteAjaxScroll('.parties-list', {
            item: itemSelector,
            pagination: '.pagination',
            next: '.pagination a[rel=next]',
            spinner: {
                // element to show as spinner
                element: '.ias-spinner',

                // delay in milliseconds
                // this is the minimal time the loader should be displayed. If loading takes longer, the spinner
                // will be shown for the duration of the loading. If the loading takes less then this duration,
                // say 300ms, then the spinner is still shown for 600ms.
                delay: 600,

                // this function is called when the button has to be shown
                show: function (element) {
                    element.style.display = 'block'; // default behaviour
                },

                // this function is called when the button has to be hidden
                hide: function (element) {
                    element.style.display = 'none'; // default behaviour
                }
            },
            trigger: {
                // element to show as trigger
                element: '.ias-trigger-next',

                // pass a function which returns true which determines if the load more button should be shown
                when: function (pageIndex) {
                    return pageIndex > 1;  // default behaviour (always show a trigger)
                },

                // this function is called when the button has to be shown
                show: function (element) {
                    element.style.display = 'block'; // default behaviour
                },

                // this function is called when the button has to be hidden
                hide: function (element) {
                    element.style.display = 'none'; // default behaviour
                }
            }
        });

        ias.on('loaded', function (response) {
            response.items.forEach(loadPremiumStats);
        });

        ias.on('last', function () {
            let el = document.querySelector('.ias-noneleft');

            el.style.display = 'block';
        })
    }

    const clipRiotId = new ClipboardJS('.copy-btn[data-copy="riot-id"]');
    const clipDiscord = new ClipboardJS('.copy-btn[data-copy="discord"]');
    const clipPartyLink = new ClipboardJS('.copy-btn[data-copy="party-link"]');

    clipRiotId.on('success', function (e) {
        showToast(t('Riot ID скопировано в буфер обмена'));
        trackInteraction(e.trigger, 'copy_riot_id');

        gtag('event', 'party_copy_btn', {
            'event_category': 'Party Card Copy Button',
            'event_label': 'Riot ID',
        });
    });

    clipDiscord.on('success', function (e) {
        showToast(t('Discord Tag скопирован в буфер обмена'));
        trackInteraction(e.trigger, 'click_discord');

        gtag('event', 'party_copy_btn', {
            'event_category': 'Party Card Copy Button',
            'event_label': 'Discord',
        });
    });

    clipPartyLink.on('success', function (e) {
        showToast(t('Ссылка на заявку скопирована в буфер обмена'));

        gtag('event', 'party_copy_btn', {
            'event_category': 'Party Card Copy Button',
            'event_label': 'Party link',
        });
    });

    on('click', '.copy-btn', (ev) => ev.preventDefault());

    // The entry point (data-cta) and the loaded URL go along with the loaded event, so the create form can attribute
    // its GA events and come back after the Riot login
    on('click', '[data-modal-open]', function (e, link) {
        e.preventDefault();
        openModal(link.dataset.modalOpen, link.getAttribute('href'), link.dataset.cta);
    });

    // The hash opens the create form. #create[=source] is a new entry into the page's own form (body data-create-url),
    // llms.txt links to it. #reopen=<source>&form=<path> brings back the form that was open when the Riot login
    // started, with its original entry point. The hash is dropped so the reload after publishing doesn't reopen the form
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const verb = ['create', 'reopen'].find((key) => hash.has(key));
    if (verb) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        const source = /^\w+$/.test(hash.get(verb)) ? hash.get(verb) : 'hash';
        const form = hash.get('form') || '';
        if (verb === 'create') {
            const modal = document.getElementById('main-modal');
            modal.addEventListener('modal:loaded', function () {
                trackCreateCta(source, modal.querySelector('form')?.classList.contains('team-form') ? 'team' : 'party');
            }, {once: true});
        }
        openModal('#main-modal', /^\/[\w/-]+$/.test(form) ? form : document.body.dataset.createUrl, source);
    }

    // Enter submits the open modal's step (Escape is handled by the dialog, which keeps focus inside while open)
    // A rendered element: :visible in jQuery terms, a step's button hidden with .hidden has no boxes
    const visible = (el) => el.getClientRects().length > 0;
    document.getElementById('main-modal')?.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.target.matches('textarea, input')) {
            e.preventDefault();
            const button = [...this.querySelectorAll('.pf-btn-check')].find(visible)
                || [...this.querySelectorAll('.pf-btn-publish')].find(visible);
            button?.click();
        }
    });

    on('click', '.switch-translation', function (ev, link) {
        ev.preventDefault();

        const showOriginal = link.dataset.translationTarget === 'original';
        const parentBlock = link.closest('.card-desc-wrap');
        parentBlock.querySelector('.translated-block').classList.toggle('hidden', showOriginal);
        parentBlock.querySelector('.original-block').classList.toggle('hidden', !showOriginal);
    });

    // Party Card: Expand/collapse stats (AJAX load on first open)
    on('click', '.expand-trigger', function (ev, trigger) {
        ev.preventDefault();
        const panel = document.getElementById(trigger.dataset.target);

        const open = trigger.classList.toggle('open');
        trigger.setAttribute('aria-expanded', String(open));
        panel.classList.toggle('open', open);

        if (open) {
            loadStats(panel, trigger.dataset.statsUrl);
        }
    });

    // Party Card: Expand/collapse matches (no AJAX, already loaded with stats)
    on('click', '.matches-trigger', function (ev, trigger) {
        ev.preventDefault();
        trigger.classList.toggle('open');
        document.getElementById(trigger.dataset.target).classList.toggle('open');
    });
});
